export const classes = {
  block:
    'rounded-[14px] border border-hair bg-black/[0.04] p-[14px] dark:border-hair-dark dark:bg-white/[0.07]',
  notice:
    '[text-wrap:pretty] text-xs leading-[1.55] text-taupe-2 dark:text-mauve-2',
  row: 'flex cursor-pointer gap-2.5',
  firstRow: 'mt-3',
  secondRow: 'mt-2.5',
  box: 'mt-px flex size-[19px] flex-none items-center justify-center rounded-md transition-all duration-150',
  boxChecked: 'border border-transparent bg-grad dark:bg-grad-dark',
  boxUnchecked:
    'border border-hair bg-panel dark:border-hair-dark dark:bg-panel-dark',
  tick: 'text-white transition-opacity duration-[120ms]',
  tickChecked: 'opacity-100',
  tickUnchecked: 'opacity-0',
  label:
    '[text-wrap:pretty] text-xs leading-[1.5] text-taupe-3 dark:text-mauve-1',
  link: 'text-brand-accent hover:opacity-80 dark:text-brand-accent-dark',
};
